import styled from 'styled-components';
import { variant } from 'styled-system';
import themeUtilities from '../../../../theme/ThemeUtilities';
import { HeaderVariant } from '../types';

export const TableHead = styled.thead<{ variant: HeaderVariant }>`
  width: 100%;
  display: flex;
  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'Table', 'header'))};
`;
TableHead.defaultProps = {
  variant: 'primary',
};
